import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import { AppMisc } from "../../misc/appMisc";
import { AppUtils } from "../../utils/appUtils";

export default function LabReportSubHeader({ data }) {
  return (
    <Box mb={2}>
      <Grid container spacing={1}>
        <Grid item xs={4}>
          <Typography variant="body2"><strong>नाम:</strong> {data.patientFirstName} {data.patientLastName}</Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography variant="body2"><strong>प्रयोगशाला दर्ता नं:</strong> {data.labNumber}</Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography variant="body2"><strong>दर्ता मिति:</strong> {AppMisc.getDateLabelFromMillisecond(data.dartaaMiti)}</Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography variant="body2"><strong>लिङ्ग:</strong> {AppMisc.getGenderLabel(data.gender)}</Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography variant="body2"><strong>उमेर:</strong> {AppUtils.replaceWithNepaliDigit(data.age)}{" "}{AppMisc.getAgeUnitLabel(data.ageUnit)}</Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography variant="body2"><strong>वडा नं:</strong> {AppUtils.replaceWithNepaliDigit(data.wardNumber)}</Typography>
        </Grid>
      </Grid>
    </Box>
  );
}
